import { Box, Button, Chip, CircularProgress, TextField, Typography } from '@material-ui/core'
import React, { useState } from 'react'

import { Spacer } from '@vestaboard/installables'
import { useAITagGeneration } from '../../../api/useAITagGeneration'
import { useTagMessage } from '../hooks/useTagMessage'

interface IMessageTags {
  messageId?: string
  tags: string[]
  onUpdateTags?: (id: string, tags: string[]) => void
  onUpdateTagsOnChange?: (tags: string[]) => void
}

export const MessageTags = (props: IMessageTags) => {
  const [tagMessageMutation, { loading }] = useTagMessage()
  const [tags, setTags] = useState(props.tags)
  const [text, setText] = useState('')
  const [isDirty, setIsDirty] = useState(false)
  const { generateTagsWithAI, loading: loadingAiTagGeneration } = useAITagGeneration()

  const handleGenerateTags = async () => {
    try {
      const res = await generateTagsWithAI({ seedWords: tags, existingTags: tags })

      if (!res?.suggestedTags?.length) {
        throw new Error('Failed to generate tags.')
      }

      setTags([...props.tags, ...res?.suggestedTags])
      setIsDirty(true)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Box>
      <Spacer size='large' />
      <Typography variant='h5'>Tags</Typography>
      <Spacer size='small' />
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap'
        }}>
        {tags.map((tag, index) => (
          <Chip
            key={index}
            label={tag}
            onDelete={() => {
              setIsDirty(true)
              setTags(tags.filter(t => t !== tag))
            }}
            style={{
              margin: 4
            }}
          />
        ))}
        <div style={{ width: '100%', height: 12 }} />
        <TextField
          style={{
            marginLeft: 4
          }}
          value={text}
          variant='outlined'
          size='small'
          placeholder='Message Tags (Comma separated)'
          fullWidth
          multiline
          minRows={2}
          onChange={e => {
            setText(e.target.value)
          }}
          onBlur={() => {
            if (text !== '') {
              setIsDirty(true)
            }
            const newTags = [...tags, ...text.split(',').map(tag => tag.trim())].filter(tag => tag !== '')
            setTags(newTags)
            if (props.onUpdateTagsOnChange) {
              props.onUpdateTagsOnChange?.(newTags)
            }
            setText('')
          }}
        />
        <div style={{ width: '100%', height: 12 }} />
        {props.messageId ? (
          <Button
            style={{
              marginLeft: 8
            }}
            size='small'
            variant='contained'
            color='primary'
            disabled={loading || !isDirty}
            onClick={async () => {
              if (props.messageId) {
                await tagMessageMutation({
                  variables: {
                    id: props.messageId,
                    tags
                  }
                })

                props.onUpdateTags?.(props.messageId, tags)
              }
              setIsDirty(false)
            }}>
            {loading ? <CircularProgress /> : 'Save Tags'}
          </Button>
        ) : null}
        {props.messageId ? (
          <Button
            style={{
              marginLeft: 8
            }}
            size='small'
            variant='contained'
            color='primary'
            disabled={loading}
            onClick={handleGenerateTags}>
            {loadingAiTagGeneration ? <CircularProgress /> : 'Generate Tags ✨'}
          </Button>
        ) : null}
      </Box>
    </Box>
  )
}
